import { ObservableArray, View } from "binder"
import { AccessManagementViewModel, UiForm, User } from "./accessManagement-viewModel"

export class AccessManagementView extends View<AccessManagementViewModel>{
    GetViewUniqueId(): string {
        return "V-9A587645-727C-4275-8A7D-1A07862A039F"
    }
    loadHtml(): string {
        let element = require('./accessManagement.html').default;
        let style = require('./accessManagement.less');
        return element;
    }
    constructor() {
       super();
    }

    public set users(v: ObservableArray<User>) { this._users = v; } public get users(): ObservableArray<User> { return this._users;} private _users: ObservableArray<User>;
    public set forms(v: ObservableArray<UiForm>) { this._forms = v; } public get forms(): ObservableArray<UiForm> { return this._forms;} private _forms: ObservableArray<UiForm>;
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    public set selectAll(v: boolean) { this._selectAll = v; } public get selectAll(): boolean { return this._selectAll;} private _selectAll: boolean;
    
    refresh(){
        this.dataContext.refresh();
    }

    save(){
        this.dataContext.save()
    }
}
